import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  selectedProject: '',
  projectType: '',
  selectedType: '',
  selectedCategory: '',
  selectedDueDate: '',
  selectedOwner: '',
  pageSize: 10,
  currentPage: 1,
  totalPages: 1,
  goToPage: 1,
  totalRecords: 1,
}

export const rfxFilterValuesSlice = createSlice({
  name: 'set-rfx-filter-values',
  initialState,
  reducers: {
    setSelectedProject: (state, action) => {
      state.selectedProject = action.payload
    },
    setProjectType: (state, action) => {
      state.projectType = action.payload
    },
    setSelectedType: (state, action) => {
      state.selectedType = action.payload
    },
    setSelectedCategory: (state, action) => {
      state.selectedCategory = action.payload
    },
    setSelectedDueDate: (state, action) => {
      state.selectedDueDate = action.payload
    },
    setSelectedOwner: (state, action) => {
      state.selectedOwner = action.payload
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload
    },
    setGoToPage: (state, action) => {
      state.goToPage = action.payload
    },
    setTotalRecord: (state, action) => {
      state.totalRecords = action.payload
    },
  },
})

export const {
  setSelectedProject,
  setProjectType,
  setSelectedType,
  setSelectedCategory,
  setSelectedDueDate,
  setSelectedOwner,
  setPageSize,
  setCurrentPage,
  setTotalPages,
  setGoToPage,
  setTotalRecord,
} = rfxFilterValuesSlice.actions

export default rfxFilterValuesSlice.reducer
